import { getUsersBackend } from "../../utils/requests/getUsersBackend";
import useTokenHook from "../context/useTokenHook";
import logger from "../../lib/logger";
import useUser from "../context/userHook";
import useSWR from "swr";
import { MondayApiQueryInstance } from "../../services/monday/monday-service-ts";

const useAuthorizedBoardUsers = (boardId: number) => {
  const { accountId } = useUser();
  const { token } = useTokenHook();

  const fetchAllUsers = async (accountId: number, token: string) => {
    try {
      const backendResponse: any = await getUsersBackend(token, accountId);

      if (backendResponse?.data?.data) {
        const userIds = backendResponse?.data?.data?.map((user: any) => user.userid);

        const authorizedUsers = await MondayApiQueryInstance.getAuthorizedBoardUsers(boardId);

        //filter out users that are not in the backend response
        const filteredUsers = authorizedUsers.filter((user: any) => userIds.includes(user.id));

        return filteredUsers;
      }

      return [];
    } catch (err: any) {
      logger.error("Error fetching users:", err);
      throw err;
    }
  };

  const { data, error, isLoading } = useSWR(accountId && token && boardId ? ["authorizedUsers", accountId, token, boardId] : null, () =>
    fetchAllUsers(accountId!, token!)
  );

  return {
    authorizedUsers: data || [],
    error,
    isLoading,
  };
};

export default useAuthorizedBoardUsers;
